<div class="fp-row">
  <span class="fp-label"><ng-content></ng-content></span>
  <span class="fp-chip" [title]="rawPath">
    <mat-icon class="fp-icon">{{ isRoot ? 'folder_open' : 'folder' }}</mat-icon>
    <!--
      The root crumb is always shown, and always named "My Projects" —
      the same words the Projects screen title and the Move dialogs'
      breadcrumb buttons use. Showing the path itself here ("/") is
      what made this line unreadable.
    -->
    <span class="fp-crumb fp-crumb-root" i18n="@@My Projects">My Projects</span>
    <ng-container *ngFor="let segment of segments">
      <mat-icon class="fp-sep">{{separatorIcon}}</mat-icon>
      <span class="fp-crumb">{{segment}}</span>
    </ng-container>
  </span>
</div>
